export class DsrDirectoryConstants {
  static RootPath = '/';
}
